import gql from 'graphql-tag';

export const GetFeatureFlagsByUser = gql`
  query GetFeatureFlagsByUser($userId: ID!) {
    getFeatureFlagsByUser(userId: $userId)
  }
`;
